<template>
    <v-container fluid class="text-xs-center"> 
        <v-text-field
            v-model="searchedText"
            :placeholder="$t('labels.search')"
          ></v-text-field>
        <div class="results-count">{{species.length}} {{$t('labels.results')}}<span v-if="searchedText!=''">, {{filteredSpecies.length}} Corrispondenze</span></div>
        <v-layout row wrap justify-center :class="multiselect?'multiselecting':'not-multiselecting'">
            <v-flex xs12 md10>
                <v-card 
                    v-for="speciesSingle in visibleSpecies" :key="speciesSingle.id" 
                    :class="selectedSpecies.includes(speciesSingle.id) ? 'selected' : ''"
                    @click="speciesClicked(speciesSingle)"
                >
                    <v-card-text>
                        <div class="card-checkbox" v-if="multiselect"><v-icon>check</v-icon></div>
                        <div class="inline-block" style="max-width: calc(100% - 70px);">
                            <strong style="font-style:italic;">{{speciesSingle.genus}} {{speciesSingle.species}}</strong><br>
                            {{$t('labels.family')}}: {{speciesSingle.family}}<br>
                            {{$t('labels.order')}}: {{speciesSingle.order}}<br>
                            <span v-if="speciesSingle.suborder">Sottordine: {{speciesSingle.suborder}}</span>
                        </div>
                        <div class="card-chev" v-if="!multiselect"></div>
                    </v-card-text>
                </v-card>
                <v-btn v-show="filteredSpecies.length>maxElements" @click="maxElements+=100" style="background:#4caf50;color:white;">
                    {{$t('labels.moreResults')}}...
                </v-btn>
            </v-flex>
        </v-layout>
        <v-dialog
            v-model="showDeletionDialog"
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{$t('labels.confirmDeletion')}}
                </v-card-title>
                <v-card-text>
                    {{$t('labels.reallyDelete')}} {{selectedSpecies.length}} specie?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="showDeletionDialog = false"
                >
                    No
                </v-btn>
                <v-btn
                    color="red"
                    style="color:white"
                    text
                    @click="deleteSpecies();showDeletionDialog = false"
                >
                    {{$t('labels.yesDelete')}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="bottom-bar-holder">
            <div class="bottom-bar">
                <v-layout
                    justify-center
                    style="padding:0"
                >
                    <v-btn
                        color="white"
                        style="background:#212121;font-size:20px;float:right;"
                        @click.native="selectedSpecies=[];multiselect=!multiselect;showToast=true"
                        flat
                    >
                        <v-icon v-if="multiselect">deselect</v-icon>
                        <v-icon v-else>select_all</v-icon>
                        &nbsp;&nbsp;{{$t('labels.multipleSelection')}}
                    </v-btn>
                    <v-btn
                        color="white"
                        style="background:rgb(244, 67, 54);font-size:20px;float:right;"
                        flat
                        v-if="multiselect"
                        @click.native="showDeletionDialog=true"
                    >
                        <v-icon>delete</v-icon>&nbsp;&nbsp;{{$t('labels.deleteSelected')}}
                    </v-btn>
                    <v-btn
                        color="white"
                        style="background:#4caf50;font-size:20px;float:right;"
                        v-if="!multiselect"
                        @click.native="$router.push({name: 'speciesAdd'})"
                        flat
                    >
                        <v-icon>add</v-icon>&nbsp;&nbsp;{{$t('views.AddSpecies')}}
                    </v-btn>
                </v-layout>
            </div>
        </div>
        <v-snackbar v-model="showToast" top>
            {{$t('labels.multiselect')}} {{multiselect?$t('labels.activated'):$t('labels.deactivated')}}
        </v-snackbar>
        <v-snackbar v-model="deletedConfirmToast" top>
            Specie eliminate con successo
        </v-snackbar>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'Species',
    data: function(){
        return{
            searchedText: "",
            species:[],
            selectedSpecies:[],
            multiselect: false,
            showDeletionDialog:false,
            deletedConfirmToast:false,
            showToast: false,
            maxElements: 100
        };
    },
    computed: {
        filteredSpecies(){
            let vm = this;
            if(vm.searchedText=='')
                return vm.species;
            return vm.species.filter(function(el){
                return JSON.stringify(el).toUpperCase().includes(vm.searchedText.toUpperCase());
            });
        },
        visibleSpecies(){
            let vm = this;
            return vm.filteredSpecies.slice(0, vm.maxElements);
        }
    },
    mounted: function(){
        let vm = this;
        vm.getSpecies();
    },
    methods:{
        deleteSpecies(){
            let vm = this;
            axios({
                method: "DELETE",
                url: vm.$API_BASE_URL + "species/delete.php",
                data: {
                    "species":vm.selectedSpecies
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.selectedSpecies=[];
                    vm.getSpecies();
                    vm.deletedConfirmToast = true;
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        },
        speciesClicked(speciesSingle){
            let vm = this;
            if(vm.multiselect){
                if(vm.selectedSpecies.includes(speciesSingle.id)){
                    vm.selectedSpecies.splice(vm.selectedSpecies.indexOf(speciesSingle.id),1);
                }
                else{
                    vm.selectedSpecies.push(speciesSingle.id);
                }
            }
            else{
                vm.$router.push({name: 'speciesSingle', params:{speciesId:speciesSingle.id}});
            }
        },
        getSpecies(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "species/getCollection.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.species = [];
                    vm.species = response.data.resources;
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        }
    }
}
</script>

